<template>
  <button
    class="Toggle__menu"
    aria-label="Menu Toggle"
    @click.prevent="toggle"
  >
    <span>Menu</span>
    <i class="icon">
      <span class="dot" />
      <span class="dot" />
      <span class="dot" />
    </i>
  </button>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'
import { menu, useMenu } from '@/store/menu'

export default {
  mounted() {
    Inertia.on('finish', () => {
      const { isOpen } = menu.value
      if( isOpen ) useMenu.close()
    })
  },
  methods: {
    toggle() {
      const { isOpen } = menu.value
      isOpen ? useMenu.close() : useMenu.open()
    }
  }
}
</script>

<style lang="scss">
  @import "~@sass/components/_MenuToggle.scss";
</style>
